import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';

import styles from './InfoCard.module.scss';

const InfoCard = React.memo(({ title, item, children }) => {
  return (
    <Card className={styles.cardItem}>
      <Card.Content className={`flex items-center ${styles.cardContent}`}>
        {children}
        <div className="inline-block">
          <Card.Header className={`text-sm font-medium text-grey ${styles.cardHeader}`}>
            {title}
          </Card.Header>
          <Card.Description className={`font-semibold text-lg ${styles.cardDesc}`}>
            <span className={styles.cardValue}>
              {item.valid
                ? parseFloat(item.sum).toLocaleString('en-GB', {
                    minimumFractionDigits: item.decimalPoint,
                    maximumFractionDigits: item.decimalPoint,
                  })
                : '-'}
            </span>
            <span className={styles.cardUnit}>{item.unitName}</span>
          </Card.Description>
        </div>
      </Card.Content>
    </Card>
  );
});

InfoCard.propTypes = {
  title: PropTypes.string,
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  children: PropTypes.element.isRequired,
};

InfoCard.defaultProps = {
  title: undefined,
};

export default InfoCard;
